import React, { useState } from "react";
import { SketchPicker as ColorPicker } from "react-color";

import { Radio } from "@material-ui/core";

import { TemplateConfig, AppearanceConfig } from "../../../../constants";
import { hexToRgb } from "../../../../utils";
import { ImageUploader } from "../../../../widgets";

import style from "../../style.module.css";
import { IMAGE_SECTION_KEY_PATH } from "features/Common/modules/ExlyImage/constants/ExlyImage.constants";

const BACKGROUND_TYPES = {
  IMAGE: "IMAGE",
  COLOR: "COLOR",
};

const TemplateBgSelector = ({ state, setField, template, disableAllEdits }) => {
  const allowColorAsBg = AppearanceConfig.allowColorAsBg.includes(template);
  // Either the cover image isn't initialised or if the value starts with an http
  const isValidImage =
    !state?.cover_image || state?.cover_image?.startsWith("http");

  const defaultBackgroundType =
    allowColorAsBg && state?.social_info?.cover_pic_type === "color"
      ? BACKGROUND_TYPES.COLOR
      : BACKGROUND_TYPES.IMAGE;

  // Val is the temporary value shown when the color picker drag is happening. This temporary
  // value is used instead of the main state to prevent spamming the iframe with color updates.
  const [val, setVal] = useState(null);
  const [selectedValue, setSelectedValue] = useState(state.cover_image);
  const [backgroundType, setBackgroundType] = useState(defaultBackgroundType);

  const handleChange = (val) => {
    setBackgroundType(val);
    setField(["social_info", "cover_pic_type"], val?.toLocaleLowerCase());
    if (val === BACKGROUND_TYPES.IMAGE) {
      setSelectedValue(state.cover_image);
    } else {
      setSelectedValue(
        `rgb(${
          state?.theme?.codes?.colors?.["template-page-background"] || "6, 6, 6"
        })`
      );
    }
  };

  return (
    <div className={style.imageOrBgSelector}>
      <div className={style.themeFieldGroupTitle}>Template Background</div>
      <div className={style.templateBgSelector}>
        {allowColorAsBg
          ? Object.values(BACKGROUND_TYPES).map((bgType) => (
              <div
                key={bgType}
                title={bgType.toLowerCase()}
                className={style.bgOptionLabel}
                onClick={() => handleChange(bgType)}
              >
                {`${bgType[0].toLocaleUpperCase()}${bgType
                  .slice(1)
                  .toLocaleLowerCase()}`}
                <Radio
                  checked={backgroundType === bgType}
                  onChange={() => handleChange(bgType)}
                  value={bgType}
                  name="template-background-option"
                  disabled={disableAllEdits}
                />
              </div>
            ))
          : null}
      </div>
      <div className={style.fieldContainer}>
        <div className={style.field}>
          {backgroundType === BACKGROUND_TYPES.IMAGE ? (
            <ImageUploader
              uploadUrl={isValidImage ? state.cover_image : null}
              setUploadUrl={(firebaseUrl) => {
                setField("cover_image", firebaseUrl);
              }}
              hoverText="Upload Background Image"
              customImageLabel="Select Background Image"
              width={250}
              height={
                250 /
                TemplateConfig?.[state?.template?.slug || "modern"]?.coverImage
                  ?.aspect_ratio
              }
              fullWidth={
                TemplateConfig?.[state?.template?.slug || "modern"]?.coverImage
                  ?.width
              }
              className={style.templateBgImgUploader}
              borderRadius="0%"
              query={"wallpaper"}
              id="template_background_theme_image"
              disabled={disableAllEdits}
              uploadViaOptimization
              sectionName={IMAGE_SECTION_KEY_PATH.HOME_PAGE}
            />
          ) : (
            <ColorPicker
              {...{
                ...((val || selectedValue) && { color: val || selectedValue }),
              }}
              className={style.templateBgColorPicker}
              disableAlpha
              presetColors={[]}
              onChange={(cVal) => {
                setVal(cVal.hex);
              }}
              onChangeComplete={(cVal) => {
                setVal(null);
                setSelectedValue(`rgb(${hexToRgb(cVal.hex)})`);
                setField("cover_image", `rgb(${hexToRgb(cVal.hex)})`);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TemplateBgSelector;
